import { createSelector } from 'reselect';
import PredesTransactionsHistoryColumns from '../../containers/PredesTransactionsHistoryColumns';
import TableDefinitions from '../../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.PREDES_TRANSACTIONS_HISTORY.isLoading;
export const getData = TableDefinitions.PREDES_TRANSACTIONS_HISTORY.getDataFunction();
export const getColumns = createSelector(getData, PredesTransactionsHistoryColumns);
